import { DivProps } from "types/dom";

export default function GreyBox ( { children, className, ...otherProps }: DivProps) {
  return <div className={`p-4 border-1 border-black bg-almostWhite rounded-lg ${className || ""}`} {...otherProps}>
    {children}
  </div>;
};